export class SituacaoPlano {

	static CADASTRADO: string = "CAD";
	static EM_PREENCHIMENTO: string = "EPR";
	static FINALIZADO: string = "FIN";

	public cod_situacao_plano: number;
	public dsc_situacao_plano: string;
	public sgl_situacao_plano: string;
	public num_ordem: number;
}
